import React, { Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { USER_ROLE } from 'constants';
import { getUserRole, getTarifName } from 'utils';
import { getNumEnding } from '../utils';
import { loadCompanyProfiles } from 'actions/profile';
import PayForTarifBtn from '../PayForTarifBtn';
import iconAlert from 'assets/images/icons/alert.svg';
import s from './style';
import { withTranslation } from 'react-i18next';

const mapStateToProps = ({ profile, profiles }) => ({
  profile,
  workersCount: profiles.data ? profiles.data.length : 0
});

@connect(mapStateToProps, { loadCompanyProfiles })
class SubscriptionBar extends Component {
  componentDidMount() {
    this.props.loadCompanyProfiles({});
  }

  render() {
    const { className, profile, workersCount, t } = this.props;
    const { tariff } = profile;
    const role = getUserRole(profile);
    const tarif = getTarifName(tariff.pricing);
    const classes = cx(s.root, className);
    const isIndividual = role === USER_ROLE.INDIVIDUAL;
    const countDay = tariff.countDay;
    const workersPercent = Math.round((workersCount / tariff.countPeople) * 100);
    const workersPercClass = `p${workersPercent > 100 ? 100 : workersPercent}`;
    return (
      <div className={classes}>
        <div className={cx(s.TarifTerm, { [s.Red]: countDay == 0 })}>
          {countDay < 6 && <img src={iconAlert} alt="" className={s.IconAlert} />}
          {countDay > 0 ?
            <span>
              {t('components.payments.subscriptionBar.title', {
                countDay: `${countDay} ${getNumEnding(countDay, [t('components.payments.subscriptionBar.day1'), t('components.payments.subscriptionBar.day2'), t('components.payments.subscriptionBar.day3')])}`,
                left: getNumEnding(countDay, [t('components.payments.subscriptionBar.left1'), t('components.payments.subscriptionBar.left2'), t('components.payments.subscriptionBar.left3')])
              })}
            </span>
            :
            <span>
              {t('components.payments.subscriptionBar.ended')}
            </span>
          }
        </div>
        <div className={s.TarifName}>
          {!isIndividual ?
            <div className={cx(s.TarifCircle, s.c100, s[workersPercClass])}>
              <div className={s.slice}>
                <div className={s.bar}></div>
                <div className={s.fill}></div>
              </div>
            </div> : null}
          <div className={s.TarifNameMain}>
            <div>
              {t('components.payments.subscriptionBar.tarif', { tarif })}
            </div>
            {!isIndividual &&
              <div className={s.TarifNameWorkers}>
                {t('components.payments.subscriptionBar.workers', {
                  workersCount,
                  countPeople: tariff.countPeople
                })}
              </div>
            }
          </div>
        </div>
        {isIndividual ? <div
          className={s.TarifText}
          dangerouslySetInnerHTML={{ __html: t('components.payments.subscriptionBar.text') }}
        /> : null}
        {isIndividual &&
          <PayForTarifBtn className={cx(s.PayForTarifBtn, 'button-primary', 'button-primary--lg')} />
          // :
          // <ShowTarifBtn />
        }
      </div>
    );
  }
}

export default withTranslation()(SubscriptionBar);



// WEBPACK FOOTER //
// ./src/components/Payments/SubscriptionBar/SubscriptionBar.js